import {DOCUMENT,isPlatformBrowser} from '@angular/common';
import {inject,PLATFORM_ID,provideEnvironmentInitializer} from '@angular/core';
import {MatIconRegistry} from '@angular/material/icon';
import {DomSanitizer} from '@angular/platform-browser';

export const APP_ICONS=[
	'app-facebook',
	'app-x',
	'app-instagram',
	'app-whatsapp'
] as const;

export const IconsProvider=provideEnvironmentInitializer(():void=>{
	const matIconRegistry=inject(MatIconRegistry);
	const domSanitizer=inject(DomSanitizer);
	if(isPlatformBrowser(inject(PLATFORM_ID))){
		const {origin}=inject(DOCUMENT).location;
		for(const icon of APP_ICONS){
			matIconRegistry.addSvgIcon(icon,domSanitizer.bypassSecurityTrustResourceUrl(`${origin}/images/${icon.replace('app-','icon-')}.svg`));
		}
	}else{
		const placeholder=domSanitizer.bypassSecurityTrustHtml('<svg xmlns="http://www.w3.org/2000/svg"></svg>');
		for(const icon of APP_ICONS){
			matIconRegistry.addSvgIconLiteral(icon,placeholder);
		}
	}
});
